












































import { defineComponent, ref, watch, computed } from '@vue/composition-api';
import { FitHalfScreenDialogV2, FitButton } from '@tencent/wphk-ui';
import { useHalfStamp } from '@/hooks/use-half-stamp';
import StampList from './stamp-list.vue';
import { useStampStore } from '@/store/stamp';
import { i18n } from '@/i18n';
import { storeToRefs } from 'pinia';
import { ArrowRightIcon } from '@tencent/wphk-icon-vue';
import { useRecordNewFeatureNotice } from '@/store/record';
import { biClick } from '@tencent/fit-bi-sdk';

export default defineComponent({
  components: {
    FitHalfScreenDialogV2,
    StampList,
    FitButton,
    ArrowRightIcon,
  },
  setup() {
    const refHalfStamp = ref<InstanceType<typeof FitHalfScreenDialogV2> | null>(null);

    const { isShowHalfStamp, hideHalfStamp } = useHalfStamp();
    watch(isShowHalfStamp, () => {
      if (isShowHalfStamp.value) {
        refHalfStamp.value?.showDialog();
      } else {
        refHalfStamp.value?.hideDialog();
      }
    });
    /** 摘要信息 */
    const { remainCount, userTotalCount, userUsedCount } = storeToRefs(useStampStore());
    const summaryInfo = computed(() => ([{
      title: i18n('結餘'),
      value: remainCount.value,
      isHighlight: true,
    }, {
      title: i18n('已儲'),
      value: userTotalCount.value,
    }, {
      title: i18n('已兌'),
      value: userUsedCount.value,
    }]));

    const recordNewFeatureNoticeStore = useRecordNewFeatureNotice();
    const { setRead } = recordNewFeatureNoticeStore;
    const { isRead } = storeToRefs(recordNewFeatureNoticeStore);

    const handleGoToRecord = () => {
      setRead();
      biClick('stamp-module.stampRecord_click|印花记录入口点击');
    };

    return {
      refHalfStamp,
      summaryInfo,
      onClose: hideHalfStamp,
      i18n,
      isRead,
      handleGoToRecord,
    };
  },
});
